export default __webpack_public_path__ + "static/38-c16de829e6226bdbb910003cc2bda203.jpg";